import { render, staticRenderFns } from "./VisualEdit.vue?vue&type=template&id=55a92175&scoped=true&"
import script from "./VisualEdit.vue?vue&type=script&lang=js&"
export * from "./VisualEdit.vue?vue&type=script&lang=js&"
import style0 from "./VisualEdit.vue?vue&type=style&index=0&id=55a92175&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a92175",
  null
  
)

export default component.exports